// Tells open views of a patient's agent context that it changed elsewhere in
// the app: an accepted update_patient_context proposal, or a save from the
// other editor (patient page vs. the sheet opened from the chat).

type Listener = (patientId: number) => void;

const listeners = new Set<Listener>();

export function emitPatientContextChanged(patientId: number): void {
  for (const l of Array.from(listeners)) l(patientId);
}

export function onPatientContextChanged(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
